"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Root = exports.Inner = void 0;
var _mui = require("@ori-ui/mui");
var _presentationUtils = require("@ori/presentation-utils");
const Root = exports.Root = (0, _mui.styled)('section', {
  shouldForwardProp: (0, _presentationUtils.shouldForwardProp)()
})(({
  isIntro,
  theme
}) => ({
  backgroundColor: theme.palette.common.white,
  borderRadius: theme.spacing(1),
  color: theme.palette.text.primary,
  display: 'grid',
  justifyContent: 'center',
  padding: theme.spacing(6, 3),
  textAlign: 'center',
  [theme.breakpoints.up('sm')]: {
    borderRadius: theme.spacing(2),
    padding: theme.spacing(isIntro ? 10 : 6, 3, 6, 3)
  }
}));
const Inner = exports.Inner = (0, _mui.styled)('div')(({
  theme
}) => ({
  display: 'grid',
  maxWidth: 600,
  gap: theme.spacing(4),
  [theme.breakpoints.up('sm')]: {
    gap: theme.spacing(6)
  }
}));
//# sourceMappingURL=styles.js.map